module.exports = __webpack_public_path__ + "assets/img/dec-red-paper.4688ca0a.png";